var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382",
    transform: "translate(3915 6555)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5785",
    "data-name": "Rectangle 5785",
    width: 91,
    height: 91,
    rx: 45.5,
    transform: "translate(-3915 -6555)",
    fill: "#ffebbe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7381",
    "data-name": "Group 7381",
    transform: "translate(-3886.75 -6526.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29983",
    "data-name": "Path 29983",
    d: "M.75,17.25A16.5,16.5,0,1,0,5.583,5.583,16.5,16.5,0,0,0,.75,17.25Z",
    fill: "none",
    stroke: "#ec9420",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29984",
    "data-name": "Path 29984",
    d: "M4.045,27.38,27.38,4.045",
    transform: "translate(1.538 1.538)",
    fill: "none",
    stroke: "#ec9420",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAllowed);
export default __webpack_public_path__ + "static/media/Not-allowed.3ac721f220baaa5949328b5a3fa3324e.svg";
export { ForwardRef as ReactComponent };